import { Typography, useTheme } from '@lingoda/ui';
import type { PropsWithChildren } from 'react';

export const ClassTileHeader = ({ children }: PropsWithChildren<unknown>) => {
    const theme = useTheme();

    return (
        <Typography
            variant="subtitle2"
            htmlColor={theme.colors.text.progress}
            sx={{ marginBottom: 1 }}
        >
            {children}
        </Typography>
    );
};
